const roadDataList = [
    {
        "road_name": "南环路西段",
        "model_id": "42_6",
        "width": "192",
        "height": "33",
        "top": "1058",
        "left": "250",
        "rotate": "353.5",
    },
    {
        "road_name": "南环路中段",
        "model_id": "42_7",
        "width": "362",
        "height": "33",
        "top": "1038",
        "left": "407",
        "rotate": "353.5",
    },
    {
        "road_name": "南环路东段",
        "model_id": "42_8",
        "width": "234",
        "height": "33",
        "top": "999",
        "left": "749",
        "rotate": "353.5",
    },
    {
        "road_name": "纬一路西段",
        "model_id": "42_9",
        "width": "324",
        "height": "33",
        "top": "945",
        "left": "237",
        "rotate": "350",
    },
    {
        "road_name": "纬一路中段",
        "model_id": "42_10",
        "width": "220",
        "height": "33",
        "top": "892",
        "left": "527",
        "rotate": "350",
    },
    {
        "road_name": "纬一路东段",
        "model_id": "42_11",
        "width": "230",
        "height": "33",
        "top": "855",
        "left": "742",
        "rotate": "350",
    },
    {
        "road_name": "西环路北段",
        "model_id": "42_12",
        "width": "167",
        "height": "33",
        "top": "421",
        "left": "164",
        "rotate": "81",
    },
    {
        "road_name": "西环路中段",
        "model_id": "42_13",
        "width": "422",
        "height": "33",
        "top": "573",
        "left": "189",
        "rotate": "80.9",
    },
    {
        "road_name": "西环路南段",
        "model_id": "42_14",
        "width": "130",
        "height": "33",
        "top": "952",
        "left": "253",
        "rotate": "81",
    },
    {
        "road_name": "纬三路西段",
        "model_id": "42_15",
        "width": "230",
        "height": "33",
        "top": "622",
        "left": "278",
        "rotate": "350",
    },
    {
        "road_name": "纬三路东段",
        "model_id": "42_16",
        "width": "221",
        "height": "33",
        "top": "587",
        "left": "481",
        "rotate": "350",
    },
    {
        "road_name": "经二路北段",
        "model_id": "42_17",
        "width": "139",
        "height": "33",
        "top": "599",
        "left": "504",
        "rotate": "439",
    },
    {
        "road_name": "经二路南段",
        "model_id": "42_18",
        "width": "184",
        "height": "33",
        "top": "718",
        "left": "527",
        "rotate": "439",
    },
    {
        "road_name": "经三路北段",
        "model_id": "42_19",
        "width": "110",
        "height": "10",
        "top": "592",
        "left": "628",
        "rotate": "440",
    },
    {
        "road_name": "经三路南段",
        "model_id": "42_20",
        "width": "65",
        "height": "10",
        "top": "691",
        "left": "634",
        "rotate": "348",
    },
    {
        "road_name": "经四路北段",
        "model_id": "42_21",
        "width": "84",
        "height": "33",
        "top": "169",
        "left": "660",
        "rotate": "442",
    },
    {
        "road_name": "经四路中北段",
        "model_id": "42_22",
        "width": "168",
        "height": "33",
        "top": "264",
        "left": "674",
        "rotate": "442",
    },
    {
        "road_name": "经四路中段",
        "model_id": "42_23",
        "width": "145",
        "height": "33",
        "top": "423",
        "left": "696",
        "rotate": "442",
    },
    {
        "road_name": "经四路中南段",
        "model_id": "42_24",
        "width": "321",
        "height": "33",
        "top": "553",
        "left": "715",
        "rotate": "442",
    },
    {
        "road_name": "经四路南段",
        "model_id": "42_25",
        "width": "136",
        "height": "33",
        "top": "865",
        "left": "760",
        "rotate": "442",
    },
    {
        "road_name": "纬四路西段",
        "model_id": "42_26",
        "width": "318",
        "height": "33",
        "top": "453",
        "left": "362",
        "rotate": "352.5",
    },
    {
        "road_name": "纬四路东段",
        "model_id": "42_27",
        "width": "218",
        "height": "33",
        "top": "410",
        "left": "680",
        "rotate": "353",
    },
    {
        "road_name": "经一路北段",
        "model_id": "42_28",
        "width": "90",
        "height": "10",
        "top": "381",
        "left": "352",
        "rotate": "79",
    },
    {
        "road_name": "经一路南段",
        "model_id": "42_29",
        "width": "142",
        "height": "10",
        "top": "468",
        "left": "369",
        "rotate": "79",
    },
    {
        "road_name": "北环路西段",
        "model_id": "42_30",
        "width": "192",
        "height": "33",
        "top": "412",
        "left": "145",
        "rotate": "-17",
    },
    {
        "road_name": "北环路中段",
        "model_id": "42_31",
        "width": "362",
        "height": "39",
        "top": "355",
        "left": "313",
        "rotate": "-19",
    },
    {
        "road_name": "北环路东段",
        "model_id": "42_32",
        "width": "232",
        "height": "33",
        "top": "241",
        "left": "656",
        "rotate": "-18",
    },
    {
        "road_name": "东环路北段",
        "model_id": "42_33",
        "width": "204",
        "height": "33",
        "top": "194",
        "left": "886",
        "rotate": "81.5",
    },
    {
        "road_name": "东环路南段",
        "model_id": "42_34",
        "width": "438",
        "height": "33",
        "top": "400",
        "left": "917",
        "rotate": "82",
    },
    {
        "road_name": "新北纬一路",
        "model_id": "42_35",
        "width": "226",
        "height": "33",
        "top": "326",
        "left": "104",
        "rotate": "-15",
    },
    {
        "road_name": "新北纬二路西段",
        "model_id": "42_36",
        "width": "95",
        "height": "33",
        "top": "209",
        "left": "209",
        "rotate": "-8.5",
    },
    {
        "road_name": "新北纬二路中段",
        "model_id": "42_37",
        "width": "354",
        "height": "33",
        "top": "197",
        "left": "297",
        "rotate": "-7.5",
    },
    {
        "road_name": "新北纬二路东段",
        "model_id": "42_38",
        "width": "224",
        "height": "33",
        "top": "152",
        "left": "638",
        "rotate": "-7.5",
    },
    /*{
        "road_name": "第一轧钢厂北路",
        "model_id": "42_39",
        "width": "387",
        "height": "10",
        "top": "80",
        "left": "454",
        "rotate": "-9",
    },*/
    {
        "road_name": "新北纬三路东段",
        "model_id": "42_40",
        "width": "202",
        "height": "40",
        "top": "-56",
        "left": "648",
        "rotate": "-8.8",
    },
    {
        "road_name": "新北纬三路中段",
        "model_id": "42_41",
        "width": "350",
        "height": "38",
        "top": "-2",
        "left": "304",
        "rotate": "-8.9",
    },
    {
        "road_name": "新北纬三路西段",
        "model_id": "42_42",
        "width": "240",
        "height": "40",
        "top": "34",
        "left": "69",
        "rotate": "-9",
    },
    {
        "road_name": "新北西路北段",
        "model_id": "42_43",
        "width": "298",
        "height": "38",
        "top": "32",
        "left": "73",
        "rotate": "79",
    },
    {
        "road_name": "新北西路南段",
        "model_id": "42_44",
        "width": "120",
        "height": "33",
        "top": "318",
        "left": "125",
        "rotate": "70",
    },
    {
        "road_name": "新北经二路北段",
        "model_id": "42_45",
        "width": "154",
        "height": "33",
        "top": "39",
        "left": "292",
        "rotate": "83",
    },
    {
        "road_name": "新北经二路中段",
        "model_id": "42_46",
        "width": "65",
        "height": "33",
        "top": "207",
        "left": "312",
        "rotate": "83",
    },
    {
        "road_name": "新北经二路南段",
        "model_id": "42_47",
        "width": "70",
        "height": "33",
        "top": "292",
        "left": "322",
        "rotate": "83",
    },
    {
        "road_name": "新北东路北段",
        "model_id": "42_48",
        "width": "107",
        "height": "37",
        "top": "-88",
        "left": "848",
        "rotate": "81.8",
    },
    {
        "road_name": "新北东路中段",
        "model_id": "42_49",
        "width": "114",
        "height": "33",
        "top": "20",
        "left": "864",
        "rotate": "83",
    },
    {
        "road_name": "新北东路南段",
        "model_id": "42_50",
        "width": "59",
        "height": "33",
        "top": "122",
        "left": "878",
        "rotate": "83",
    },
    /*{
        "road_name": "环厂北路",
        "model_id": "42_51",
        "width": "783", //"397",
        "height": "33",
        "top": "-75", //"-62",
        "left": "65", //"10",
        "rotate": "-7",
    },*/
    /*{
        "road_name": "环厂西路北段",
        "model_id": "42_52",
        "width": "207",
        "height": "10",
        "top": "425",
        "left": "102",
        "rotate": "81",
    },*/
    {
        "road_name": "环厂西路中段",
        "model_id": "42_53",
        "width": "287",
        "height": "44",
        "top": "620",
        "left": "133",
        "rotate": "80.5",
        "road_type": "parkingLot"
    },
    {
        "road_name": "环厂西路南段",
        "model_id": "42_54",
        "width": "206",
        "height": "44",
        "top": "894",
        "left": "177",
        "rotate": "80.5",
        "road_type": "parkingLot"
    },
    // {
    //  "road_name": "于唐线东北段（南北向）",
    //  "model_id": "42_55",
    //  "width": "149",
    //  "top": "2",
    //  "left": "1039",
    //  "rotate": "84",
    // 
    // },
    // {
    //  "road_name": "于唐线东北段（东西向）",
    //  "model_id": "42_56",
    //  "width": "235",
    //  "top": "211",
    //  "left": "823",
    //  "rotate": "-17",
    // 
    // },
    // {
    //  "road_name": "于唐线北段",
    //  "model_id": "42_57",
    //  "width": "183",
    //  "top": "149",
    //  "left": "823",
    //  "rotate": "82.1",
    // 
    // },
    // {
    //  "road_name": "于唐线中北段",
    //  "model_id": "42_58",
    //  "width": "121",
    //  "top": "329",
    //  "left": "848",
    //  "rotate": "82.1",
    // 
    // },
    // {
    //  "road_name": "于唐线中段",
    //  "model_id": "42_59",
    //  "width": "171",
    //  "top": "448",
    //  "left": "864",
    //  "rotate": "82.1",
    // 
    // },
    // {
    //  "road_name": "于唐线中南段",
    //  "model_id": "42_60",
    //  "width": "188",
    //  "top": "616",
    //  "left": "887",
    //  "rotate": "82.1",
    // 
    // },
    // {
    //  "road_name": "于唐线南段",
    //  "model_id": "42_61",
    //  "width": "278",
    //  "top": "799",
    //  "left": "913",
    //  "rotate": "82.1",
    // 
    // },
    // {
    //  "road_name": "于唐线西南段（东西向）",
    //  "model_id": "42_62",
    //  "width": "450",
    //  "top": "1155",
    //  "left": "508",
    //  "rotate": "-11",
    // 
    // },
    // {
    //  "road_name": "于唐线西南段（南北向）",
    //  "model_id": "42_63",
    //  "width": "358",
    //  "top": "1019",
    //  "left": "492",
    //  "rotate": "85",
    // 
    // },
    {
        "road_name": "新北经一路北段",
        "model_id": "42_64",
        "width": "185",
        "height": "33",
        "top": "49",
        "left": "185",
        "rotate": "81",
    },
    {
        "road_name": "新北经一路南段",
        "model_id": "42_65",
        "width": "67",
        "height": "33",
        "top": "229",
        "left": "215",
        "rotate": "81",
    }
]


const road58DataList = [{
    "road_name": "创新路东段",
    "model_id": "58_9",
    "width": "145",
    "height": "16",
    "top": "224",
    "left": "665",
    "rotate": "393.8",
}, {
    "road_name": "创新路中段",
    "model_id": "58_7",
    "width": "141",
    "height": "16",
    "top": "145",
    "left": "547",
    "rotate": "393.8",
}, {
    "road_name": "变电西路",
    "model_id": "58_10",
    "width": "70",
    "height": "16",
    "top": "264",
    "left": "823",
    "rotate": "123.8",
}, {
    "road_name": "中钢大道",
    "model_id": "58_8",
    "width": "70",
    "height": "16",
    "top": "180",
    "left": "706",
    "rotate": "123.8",
}, {
    "road_name": "特钢西路北1段",
    "model_id": "58_3",
    "width": "64",
    "height": "16",
    "top": "105",
    "left": "576",
    "rotate": "113.5",
}, {
    "road_name": "特钢西路北2段",
    "model_id": "58_4",
    "width": "66",
    "height": "16",
    "top": "160",
    "left": "568",
    "rotate": "121.5",
}, {
    "road_name": "大棒西路",
    "model_id": "58_5",
    "width": "66",
    "height": "16",
    "top": "173",
    "left": "590",
    "rotate": "122.5",
}, {
    "road_name": "特刚北路东段",
    "model_id": "58_1",
    "width": "350",
    "height": "16",
    "top": "210",
    "left": "548",
    "rotate": "393.8",
}, {
    "road_name": "特刚北路西段",
    "model_id": "58_2",
    "width": "40",
    "height": "16",
    "top": "198",
    "left": "530",
    "rotate": "393.8",
}, {
    "road_name": "特刚东路北段",
    "model_id": "58_23",
    "width": "266",
    "height": "16",
    "top": "406",
    "left": "840",
    "rotate": "126.7",
}, {
    "road_name": "特刚西路中段",
    "model_id": "58_12",
    "width": "116",
    "height": "16",
    "top": "292",
    "left": "500",
    "rotate": "113.7",
}, {
    "road_name": "特刚西路中北段",
    "model_id": "58_11",
    "width": "90",
    "height": "16",
    "top": "212",
    "left": "536",
    "rotate": "113.7",
}, {
    "road_name": "港西大道北段",
    "model_id": "58_28",
    "width": "303",
    "height": "16",
    "top": "78",
    "left": "543",
    "rotate": "116",
}, {
    "road_name": "港西大道中段",
    "model_id": "58_31",
    "width": "195",
    "height": "16",
    "top": "345",
    "left": "411",
    "rotate": "103",
}, {
    "road_name": "港西大道南段",
    "model_id": "58_33",
    "width": "295",
    "height": "16",
    "top": "534",
    "left": "367",
    "rotate": "98.7",
}, {
    "road_name": "特刚西路中北段",
    "model_id": "58_11",
    "width": "90",
    "height": "16",
    "top": "212",
    "left": "536",
    "rotate": "113.7",
}, {
    "road_name": "梅港河北路",
    "model_id": "58_29",
    "width": "146",
    "height": "16",
    "top": "332",
    "left": "413",
    "rotate": "214.7",
}, {
    "road_name": "梅港河南路",
    "model_id": "58_30",
    "width": "150",
    "height": "16",
    "top": "353",
    "left": "406",
    "rotate": "214.7",
}, {
    "road_name": "二桥西路",
    "model_id": "58_32",
    "width": "232",
    "height": "16",
    "top": "540",
    "left": "353",
    "rotate": "198.7",
}, {
    "road_name": "同创路",
    "model_id": "58_34",
    "width": "300",
    "height": "16",
    "top": "512",
    "left": "239",
    "rotate": "99.7",
}, {
    "road_name": "特钢西路中南段",
    "model_id": "58_14",
    "width": "204",
    "height": "16",
    "top": "392",
    "left": "455",
    "rotate": "102.7",
}, {
    "road_name": "特钢西路中北段",
    "model_id": "58_11",
    "width": "248",
    "height": "16",
    "top": "588",
    "left": "411",
    "rotate": "100.7",
}, {
    "road_name": "优线中路",
    "model_id": "58_13",
    "width": "210",
    "height": "16",
    "top": "278",
    "left": "498",
    "rotate": "393.8",
}, {
    "road_name": "胜利浜北路",
    "model_id": "58_15",
    "width": "316",
    "height": "16",
    "top": "368",
    "left": "465",
    "rotate": "387.8",
}, {
    "road_name": "胜利浜南路",
    "model_id": "58_16",
    "width": "316",
    "height": "16",
    "top": "389",
    "left": "455",
    "rotate": "387.2",
}, {
    "road_name": "南区高炉1#路",
    "model_id": "58_17",
    "width": "296",
    "height": "16",
    "top": "420",
    "left": "445",
    "rotate": "387.2",
}, {
    "road_name": "南区高炉3#路",
    "model_id": "58_18",
    "width": "296",
    "height": "16",
    "top": "440",
    "left": "440",
    "rotate": "389.2",
}, {
    "road_name": "南区高炉5#路",
    "model_id": "58_19",
    "width": "214",
    "height": "16",
    "top": "468",
    "left": "425",
    "rotate": "387.2",
}, {
    "road_name": "南区高炉7#路",
    "model_id": "58_20",
    "width": "178",
    "height": "16",
    "top": "493",
    "left": "420",
    "rotate": "390.2",
}, {
    "road_name": "二桥东路",
    "model_id": "58_21",
    "width": "153",
    "height": "16",
    "top": "530",
    "left": "415",
    "rotate": "388.2",
}, {
    "road_name": "小棒北路",
    "model_id": "58_22",
    "width": "106",
    "height": "16",
    "top": "580",
    "left": "404",
    "rotate": "369.2",
}, {
    "road_name": "特钢东路中段",
    "model_id": "58_24",
    "width": "178",
    "height": "16",
    "top": "596",
    "left": "504",
    "rotate": "364.2",
}, {
    "road_name": "特钢东路南段",
    "model_id": "58_26",
    "width": "248",
    "height": "16",
    "top": "602",
    "left": "514",
    "rotate": "99.2",
}, {
    "road_name": "特钢南路",
    "model_id": "58_27",
    "width": "186",
    "height": "16",
    "top": "822",
    "left": "350",
    "rotate": "369.2",
}];

const road89DataList = [
    {
        "road_name": "经一路北段",
        "model_id": "89_1",
        "width": "580",
        "height": "16",
        "top": "793",
        "left": "942",
        "rotate": "100.5",
    }, {
        "road_name": "经一路南段",
        "model_id": "89_2",
        "width": "210",
        "height": "16",
        "top": "547",
        "left": "949",
        "rotate": "99",
    },
    {
        "road_name": "经二路",
        "model_id": "89_3",
        "width": "360",
        "height": "16",
        "top": "550",
        "left": "818",
        "rotate": "99",
    },
    {
        "road_name": "经三路",
        "model_id": "89_4",
        "width": "357",
        "height": "16",
        "top": "914",
        "left": "754",
        "rotate": "98.5",
    },
    {
        "road_name": "经四路北段",
        "model_id": "89_5",
        "width": "353",
        "height": "16",
        "top": "896",
        "left": "587",
        "rotate": "98.5",
    },
    {
        "road_name": "经四路南段",
        "model_id": "89_6",
        "width": "323",
        "height": "16",
        "top": "563",
        "left": "636",
        "rotate": "98.5",
    },
    {
        "road_name": "经五路",
        "model_id": "89_7",
        "width": "171",
        "height": "16",
        "top": "567",
        "left": "562",
        "rotate": "97",
    },
    {
        "road_name": "经六路",
        "model_id": "89_8",
        "width": "128",
        "height": "16",
        "top": "593",
        "left": "436",
        "rotate": "97",
    },
    {
        "road_name": "经七路",
        "model_id": "89_9",
        "width": "638",
        "height": "16",
        "top": "728",
        "left": "381",
        "rotate": "97",
    },
    {
        "road_name": "经八路",
        "model_id": "89_10",
        "width": "125",
        "height": "16",
        "top": "586",
        "left": "345",
        "rotate": "97",
    },
    {
        "road_name": "经九路北段",
        "model_id": "89_11",
        "width": "184",
        "height": "16",
        "top": "1177",
        "left": "270",
        "rotate": "97",
    },
    {
        "road_name": "经九路南段",
        "model_id": "89_12",
        "width": "371",
        "height": "16",
        "top": "795",
        "left": "312",
        "rotate": "97",
    },
    {
        "road_name": "经十路",
        "model_id": "89_13",
        "width": "371",
        "height": "16",
        "top": "782",
        "left": "198",
        "rotate": "97",
    },
    {
        "road_name": "经一支一路",
        "model_id": "89_14",
        "width": "75",
        "height": "16",
        "top": "1288",
        "left": "741",
        "rotate": "100.5",
    },
    {
        "road_name": "经一支二路",
        "model_id": "89_15",
        "width": "105",
        "height": "16",
        "top": "651",
        "left": "980",
        "rotate": "101",
    },
    {
        "road_name": "纬一路",
        "model_id": "89_16",
        "width": "301",
        "height": "16",
        "top": "1358",
        "left": "518",
        "rotate": "0",
    },
    {
        "road_name": "纬二路",
        "model_id": "89_17",
        "width": "301",
        "height": "16",
        "top": "1246",
        "left": "535",
        "rotate": "8",
    },
    {
        "road_name": "纬三路",
        "model_id": "89_18",
        "width": "317",
        "height": "16",
        "top": "880",
        "left": "588",
        "rotate": "8",
    },
    {
        "road_name": "纬四路",
        "model_id": "89_19",
        "width": "385",
        "height": "16",
        "top": "690",
        "left": "207",
        "rotate": "8",
    },
    {
        "road_name": "纬五路",
        "model_id": "89_20",
        "width": "166",
        "height": "16",
        "top": "580",
        "left": "631",
        "rotate": "8",
    },
    {
        "road_name": "纬六路",
        "model_id": "89_21",
        "width": "425",
        "height": "16",
        "top": "554",
        "left": "513",
        "rotate": "-4",
    },
    {
        "road_name": "纬七路",
        "model_id": "89_22",
        "width": "160",
        "height": "16",
        "top": "770",
        "left": "198",
        "rotate": "7",
    },
    {
        "road_name": "纬九支一路",
        "model_id": "89_23",
        "width": "191",
        "height": "16",
        "top": "1026",
        "left": "136",
        "rotate": "7",
    },
    {
        "road_name": "纬九路",
        "model_id": "89_24",
        "width": "206",
        "height": "16",
        "top": "1142",
        "left": "106",
        "rotate": "7",
    },
    {
        "road_name": "纬十路",
        "model_id": "89_25",
        "width": "137",
        "height": "16",
        "top": "1250",
        "left": "105",
        "rotate": "0",
    },
    {
        "road_name": "纬十一路",
        "model_id": "89_26",
        "width": "56",
        "height": "16",
        "top": "1360",
        "left": "236",
        "rotate": "0",
    },
    {
        "road_name": "纬二支一路",
        "model_id": "89_27",
        "width": "144",
        "height": "16",
        "top": "1198",
        "left": "707",
        "rotate": "9",
    },
    {
        "road_name": "纬二支二路",
        "model_id": "89_28",
        "width": "144",
        "height": "16",
        "top": "1077",
        "left": "727",
        "rotate": "9",
    },
    {
        "road_name": "纬二支三路",
        "model_id": "89_29",
        "width": "144",
        "height": "16",
        "top": "1009",
        "left": "734",
        "rotate": "8",
    },
    {
        "road_name": "中荣北路",
        "model_id": "89_30",
        "width": "55",
        "height": "16",
        "top": "704",
        "left": "543",
        "rotate": "8",
    },
    {
        "road_name": "中荣南路",
        "model_id": "89_31",
        "width": "61",
        "height": "16",
        "top": "590",
        "left": "553",
        "rotate": "8",
    },
    {
        "road_name": "纬四支一路",
        "model_id": "89_32",
        "width": "107",
        "height": "16",
        "top": "679",
        "left": "425",
        "rotate": "8",
    },
    {
        "road_name": "纬九支二路",
        "model_id": "89_33",
        "width": "148",
        "height": "16",
        "top": "1180",
        "left": "106",
        "rotate": "8",
    },
];

export { roadDataList, road58DataList, road89DataList }